import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { motion } from 'motion/react';
import creativeData from '../../data/creativeData.json';

const Pricing = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  }

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  }

  return (
    <section className="pricing-section py-5 bg-light">
      <Container className="py-5">
        <div className="service-heading mb-3">
          <motion.h6 className="underline-after text-center position-relative z-0"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="position-relative z-1 bg-white text-primary px-3">PRICING PLANS</span>
          </motion.h6>
          <motion.h2 className="d-block text-gradiant text-center fw-semibold display-5"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Choose the Right Plan for Your Business
          </motion.h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
          <Row className="g-4">
            {creativeData.pricing.map((plan) => (
              <Col key={plan.id} md={4}>
                <motion.div variants={cardVariants}
                  whileHover={{ y: -10, scale: plan.popular ? 1.03 : 1.02, transition: { duration: 0.3 } }}
                >
                  <Card className={`border-0 shadow-sm rounded-4 h-100 ${plan.popular ? 'shadow-lg border border-primary border-2' : ''}`}>
                    <Card.Body className="p-5">
                      {plan.popular && (
                        <motion.div
                          initial={{ opacity: 0, y: -10 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true }}
                          transition={{ delay: 0.3 }}
                        >
                          <Badge bg="primary" className="position-absolute top-0 start-50 translate-middle px-3 py-2">Popular</Badge>
                        </motion.div>
                      )}

                      <h6 className="text-uppercase text-muted mb-3">{plan.name}</h6>
                      <h2 className="display-5 fw-bold mb-0">${plan.price}</h2>
                      <p className="text-muted mb-4">{plan.period}</p>

                      <ul className="list-unstyled mb-5">
                        {plan.features.map((feature, index) => (
                          <motion.li key={index} className={`mb-3 ${!feature.included ? 'text-muted' : ''}`}
                            initial={{ opacity: 0, x: -10 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.1 + 0.3 }}
                          >
                            <i className={`${feature.included ? 'ri-checkbox-circle-fill text-success' : 'ri-close-circle-line'} me-2`}></i>
                            {feature.text}
                          </motion.li>
                        ))}
                      </ul>

                      <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
                        <Button variant={plan.popular ? 'primary' : 'outline-primary'} className="w-100">Get Started</Button>
                      </motion.div>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </Container>
    </section>
  )
}

export default Pricing;
